<template>
    <div class="pb-3">

        <v-card class="cart" elevation="1">
            <div class="cart-header">
                <div class="item cart-button" :class="(!getQbet && !getPrint)? 'active' : 'deactivated'"
                     @click="switchQbetSection(false)">
                    {{$t('normal')}}
                </div>
                <div class="item my-bets" :class="(getQbet)? 'active' : 'deactivated'" @click="switchQbetSection(true)">
                    {{$t('qbet')}}
                </div>
                <div v-if="isPrintOddsVisible" class="item my-bets" :class="(getPrint)? 'active' : 'deactivated'"
                     @click="switchPrintSection(true)">
                    {{$t('printodds')}}
                </div>
            </div>

        </v-card>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {isMobileOnly} from "mobile-device-detect";
    import {checkIsMobileDevice, checkIsTabletDevice} from "../../plugins/device-inspector";

    export default {
        name: 'QuickBet',
        data: () => ({
            valid: true,
            isMobileOnly: isMobileOnly,
            errors: [],
            success: [],
        }),
        computed: {
            ...mapGetters({
                'getLanguage': 'settings/getLanguage',
                'getType': 'user/getType',
                'getQbet': 'tree/getQbet',
                'getPrint': 'tree/getPrint',
                'getCashier': 'user/getCashier',
                'getShowQuickbet': 'settings/getShowQuickbet'
            }),

            isPrintOddsVisible() {

                if (!this.getShowQuickbet) {
                    return true;
                } else if (this.getShowQuickbet) {
                    if (this.getCashier) {
                        return false;
                    }
                    return true;
                }
            },

        },
        methods: {
            ...mapActions({
                'setLoadingCart': 'cart/setLoadingCart',
                'fetchBookedBet': 'cart/fetchBookedBet',
                'setStatusQbet': 'tree/setStatusQbet',
                'setStatusPrint': 'tree/setStatusPrint'
            }),
            checkIsMobile() {
                return checkIsMobileDevice()
            },

            checkIsTablet() {
                return checkIsTabletDevice()
            },
            async switchQbetSection(status) {

                this.setStatusQbet(status)
                this.setStatusPrint(false)
                if (this.checkIsMobile()) {
                    this.$root.$emit('close_sidebar_left', true)
                }

            },
            async switchPrintSection(status) {
                //console.log("STATUS",status)
                this.setStatusPrint(status)
                this.setStatusQbet(false)
                if (this.checkIsMobile()) {
                    this.$root.$emit('close_sidebar_left', true)
                }

            }
        },

    };
</script>